/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Error_Invalid_IdentifierInputs */

const en_ledger_error_invalid_identifier = /** @type {(inputs: Ledger_Error_Invalid_IdentifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The query returned an invalid account identifier`)
};

const nl_ledger_error_invalid_identifier = /** @type {(inputs: Ledger_Error_Invalid_IdentifierInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De query gaf een ongeldige rekeningidentificatie terug`)
};

/**
* | output |
* | --- |
* | "The query returned an invalid account identifier" |
*
* @param {Ledger_Error_Invalid_IdentifierInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_error_invalid_identifier = /** @type {((inputs?: Ledger_Error_Invalid_IdentifierInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Error_Invalid_IdentifierInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_error_invalid_identifier(inputs)
	return en_ledger_error_invalid_identifier(inputs)
});